import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';
// layouts
import DashboardLayout from 'src/layouts/dashboard';
// components
import { LoadingScreen } from 'src/components/loading-screen';
import DateContextProvider from 'src/contexts/date-context';
// ----------------------------------------------------------------------

// OVERVIEW
const IndexPage = lazy(() => import('src/pages/dashboard/app'));

// USER
const UserProfilePage = lazy(() => import('src/pages/dashboard/user/profile'));
// Dynamic dashboard component that selects the correct client-specific view at render time
const DashboardWorkRequestDynamic = lazy(() => import('src/pages/dashboard/dashboard-work-request-page-dynamic'));
const CreateNewWorkRequest = lazy(() => import('src/pages/dashboard/create-new-work-request-form-page'));
const CreateWorkRequestByDepartment = lazy(() => import('src/pages/dashboard/create-work-request-by-department-page'));
const CreateWorkRequestByLocation = lazy(() => import('src/pages/dashboard/create-work-request-by-location-page'));

export const dashboardRoutes = [
  {
    path: 'dashboard',
    element: (
      <DashboardLayout>
        <DateContextProvider>
        <Suspense fallback={<LoadingScreen />}>
          <Outlet />
        </Suspense>
        </DateContextProvider>
      </DashboardLayout>
    ),
    children: [
      { element: <IndexPage />, index: true },

      {
        path: 'user',
        children: [
          { element: <UserProfilePage />, index: true },
          { path: 'profile', element: <UserProfilePage /> },
          
        ],
      },
      {
        path: 'work_request',
        children: [
          { element: <DashboardWorkRequestDynamic />, index: true },
          { path: 'home', element: <DashboardWorkRequestDynamic /> },
          { path: 'new', element: <CreateNewWorkRequest /> },
          { path: 'by_department', element: <CreateWorkRequestByDepartment /> },
          { path: 'by_location', element: <CreateWorkRequestByLocation /> },
        ],
      },
    ],
  },
];
